import { CollectionEntity } from "@busy-human/gearbox";
import { Dogspaces } from "../Dogs/index.js";
export var Kennels;
(function (Kennels) {
    // eslint-disable-next-line prefer-destructuring
    Kennels.Sizes = Dogspaces.Sizes;
    const Relationships = {};
    class CollectionClass extends CollectionEntity {
        relationships = Relationships;
        defaults() {
            return {
                date: "",
                kennelCount: {
                    [Kennels.Sizes.Small]: 0,
                    [Kennels.Sizes.Medium]: 0,
                    [Kennels.Sizes.Large]: 0,
                    [Kennels.Sizes.XLarge]: 0,
                    [Kennels.Sizes.XXLarge]: 0
                }
            };
        }
    }
    Kennels.CollectionClass = CollectionClass;
    Kennels.Collection = new CollectionClass({ path: "/Kennels" });
})(Kennels || (Kennels = {}));
//# sourceMappingURL=index.js.map